import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { supabase } from './supabaseClient';
import './Login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error'
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    setMessage('');

    try {
      // Send password reset email
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/set-password`,
      });

      if (error) throw error;

      setSubmitStatus('success');
      setMessage('Password reset instructions have been sent to your email address.');
      setEmail('');
    } catch (error) {
      console.error('Error sending password reset:', error);
      setSubmitStatus('error');
      setMessage(error.message || 'Failed to send password reset email. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center mb-4">
          <h1 className="text-white mb-2">ROE Visual DB</h1>
          <p className="text-white-50">Production Barcode Checker</p>
        </div>

        <Card style={{ maxWidth: '500px', width: '100%' }} className="shadow-lg">
          <Card.Body className="p-4">
            <div className="text-center mb-4">
              <h2>Reset Password</h2>
              <p className="text-muted">
                Enter your email address and we'll send you instructions to reset your password.
              </p>
            </div>

            {submitStatus === 'success' && (
              <Alert variant="success" onClose={() => setSubmitStatus(null)} dismissible>
                {message}
              </Alert>
            )}

            {submitStatus === 'error' && (
              <Alert variant="danger" onClose={() => setSubmitStatus(null)} dismissible>
                {message}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                  required
                />
              </Form.Group>

              <div className="d-grid">
                <Button
                  variant="primary"
                  type="submit"
                  size="lg"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Reset Instructions'}
                </Button>
              </div>
            </Form>

            <div className="text-center mt-4">
              <a href="/login" className="text-decoration-none">
                Back to Sign In
              </a>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default ForgotPassword;
